@if (isVisible) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-container" (click)="stopPropagation($event)">
      <button class="modal-close-btn" (click)="onClose()" [attr.aria-label]="'Close' | translate">
        <span class="icon-close">&times;</span>
      </button>
      <form [formGroup]="uploadForm" (ngSubmit)="onUploadSubmit()">
        <div class="modal-body">
          <div class="modal-column">
            <h3 class="modal-column-title">{{ 'UAV data upload' | translate }}</h3>
            <div class="form-group">
              <label class="form-label">{{ 'Name' | translate }} *</label>
              <msf-input
                [model]="nameControl.value"
                (modelChange)="nameControl.setValue($event)"
                (onBlur)="nameControl.markAsTouched()"
                [placeholder]="'Name' | translate"
              />
            </div>
            <div class="form-group">
              <label class="form-label" for="modal-data-type">{{ 'Data type' | translate }}</label>
              <select id="modal-data-type" class="form-input" formControlName="dataType">
                <option [ngValue]="null" selected>{{ 'Select' | translate }}</option>
                @for (type of uavDataTypes; track type.id) {
                  <option [value]="type.id">{{ type | serverTranslate:'names' }}</option>
                }
              </select>
            </div>
            <div class="form-group">
              <label class="form-label" for="modal-camera-type">{{ 'Camera type' | translate }}</label>
              <select id="modal-camera-type" class="form-input" formControlName="cameraType">
                <option [ngValue]="null" selected>{{ 'Select' | translate }}</option>
                @for (camera of cameraTypes; track camera.id) {
                  <option [value]="camera.id">{{ camera | serverTranslate:'names' }}</option>
                }
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">{{ 'Tags' | translate }}</label>
              <app-tag-selector
                [selectedTagIds]="selectedTagIds"
                (selectedTagIdsChange)="onTagIdsChange($event)"
                [allowCreate]="true"></app-tag-selector>
            </div>
            <div class="form-checkbox">
              <input type="checkbox" id="modal-analysis-only" formControlName="analysisOnly"/>
              <label for="modal-analysis-only">{{ 'ANALYSIS_ONLY' | translate }}</label>
            </div>
            <div class="form-group">
              <label class="form-label" for="modal-comment">{{ 'Comment' | translate }}</label>
              <textarea id="modal-comment" class="form-textarea" rows="4" [placeholder]="'Comment' | translate"
                        formControlName="comment"></textarea>
            </div>
          </div>
          <div class="modal-column">
            <h3 class="modal-column-title secondary">{{ 'FILE_UPLOAD' | translate }} *</h3>
            <input type="file" #fileInput hidden (change)="onFileSelected($event)"
                   [accept]="uploadAccept"/>
            <div class="file-drop-zone" (click)="fileInput.click()" (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)">
              {{ 'Drag and drop files here or' | translate }}
              <a href="#" (click)="$event.preventDefault(); $event.stopPropagation(); fileInput.click()">
                {{ 'UAV_UPLOAD_SELECT_FILE' | translate }}
              </a>
            </div>
            @if (selectedFile(); as file) {
              <div class="file-list-item">
                <span class="icon-file-pdf"></span>
                <div class="file-info">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-format">{{ selectedFileFormat() }}</span>
                </div>
              </div>
            } @else {
              <div class="file-list-item placeholder">
                <span class="file-info">{{ 'File not selected' | translate }}</span>
              </div>
            }
            @if (isSubmitting) {
              <div class="progress-info">
                <div class="progress-bar-container">
                  <div class="progress-bar-fill" [class.processing]="uploadProgress === 100"
                       [style.width.%]="uploadProgress">
                  </div>
                </div>
                <div class="progress-text">
                  @if (uploadProgress < 100) {
                    <span>{{ 'Uploading' | translate }}... {{ uploadProgress }}%</span>
                  } @else {
                    <div class="processing-status">
                  <span class="status-label">
                    <span class="icon-refresh spinning"></span>
                    {{ 'Processing on server' | translate }}...
                  </span>
                      <span class="time-label">
                    ~ {{ remainingTime }} {{ 'sec' | translate }}
                  </span>
                    </div>
                    <div class="processing-hint">
                      <small>{{ 'Do not close this window' | translate }}</small>
                    </div>
                  }
                </div>
              </div>
            }
            @if (uploadError(); as error) {
              <div class="upload-error-message">
                {{ error }}
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <app-secondary-button
            title="Cancel"
            (action)="onClose()"
          ></app-secondary-button>
          <app-primary-button
            [disable]="isSubmitting || !selectedFile()"
            [title]="(isSubmitting? 'Loading...' : 'Upload') | translate"
            (action)="onUploadSubmit()"
          ></app-primary-button>
        </div>
      </form>
    </div>
  </div>
}

<app-confirmation-modal
  [isVisible]="isCancelConfirmVisible" [title]="'Cancel upload' | translate"
  [message]="'Upload is in progress. Are you sure you want to close?' | translate"
  [confirmText]="'Yes' | translate"
  [cancelText]="'No' | translate" (confirm)="forceClose()" (cancel)="closeCancelConfirm()">
</app-confirmation-modal>
